<template>
    <div class="peopleTray" v-on:scroll="scroll($event)">
        <div class="peopleContainer">
            <div class="peopleList">
                <div class="icon-wrapper" v-for="(person, index) in people" :key="index">
                    <personicon :attendee="person" v-on:openCard="openCard"></personicon>
                </div>
                <div v-if="isEmpty" class="background-message"><div>{{$t('str.NobodyInTheSession')}}</div></div>
            </div>
            <personcard v-if="attendee" :attendee="attendee" :user="user" v-on:cardClosed="cardClosed"></personcard>
        </div>
        <spinner v-if="people === undefined" />
    </div>
</template>

<script>

// TODO: show notification when new person joins session (give corresponding notification on personIcon to know who is new)
import PersonIcon from '@/components/PersonIcon';
import PersonCard from '@/components/PersonCard';
import Spinner from '@/components/Spinner';

const TRIGGER_SCROLL_EPS = 10;

export default {
    components: {
        personicon: PersonIcon,
        personcard: PersonCard,
        spinner: Spinner
    },

    props: {
        people: {},
        user: {}
    },

    data() {
        return {
            attendee: undefined,
            userScrolled: false,
            ignoreScroll: false
        };
    },

    computed: {
        isEmpty() {
            return this.people !== undefined && !this.people.length;
        }
    },

    watch: {
        people() {
            if (!this.userScrolled) {
                this.showLastAttendeeJoined();
            }
        }
    },

    mounted() {
        this.showLastAttendeeJoined();
    },

    methods: {
        openCard(attendee) {
            this.attendee = attendee;
            this.$emit('openCard', this.attendee);
        },

        cardClosed() {
            this.attendee = undefined;
        },

        scroll(event) {
            // Block auto scroll if user is scrolling manually
            // Enable it back is user scrolled at the bottom.
            this.userScrolled = this.$el.scrollHeight - this.$el.clientHeight - this.$el.scrollTop > TRIGGER_SCROLL_EPS;
        },

        showLastAttendeeJoined() {
            setTimeout(() => {
                let maxScrollTop = this.$el.scrollHeight - this.$el.clientHeight;
                let startScrollTop = this.$el.scrollTop;
                let scrollRange = maxScrollTop - startScrollTop;
                let startScrollTime = performance.now();

                let animateScroll = (time) => {
                    let timeFraction = (time - startScrollTime) / 300;
                    
                    if (timeFraction > 1) {
                        timeFraction = 1;
                    }

                    // ease out
                    timeFraction = (--timeFraction) * timeFraction * timeFraction + 1;

                    this.$el.scrollTop = startScrollTop + scrollRange * timeFraction;

                    if (timeFraction < 1) {
                        requestAnimationFrame(animateScroll);
                    } else {
                        setTimeout(() => {
                            this.userScrolled = false;
                        }, 10);
                    }
                };

                requestAnimationFrame(animateScroll);
            }, 10);
        }
    }
};

</script>

<style lang="scss">

.peopleTray {
    position: absolute;
    width: 100%;
    top: 65px;
    bottom: 56px;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    
    .peopleContainer {
        margin: 0 auto;
        overflow: hidden;
        box-sizing: border-box;
    }

    .peopleList {
        display: flex;
        flex-flow: row wrap;
        justify-content: center;

        .icon-wrapper {
            margin:0px;
            padding:0px;
        }
    }
 
    .background-message {
        width: 100%;
        height: 100%;
        display: table;
        position: absolute;
        font-size: 0.9em;
        font-family: "Poppins", "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-weight: normal;

        & > div {
            display: table-cell;
            text-align: center;
            width: 100%;
            vertical-align: middle;
        }
    }   
}
::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  border-radius: 0;
  box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.0);
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.0);
  border-radius: 0;
}

::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(0, 0, 0, 0.0);
}

</style>



// WEBPACK FOOTER //
// PeopleTray.vue?498e3acb